import React, { FC, useState } from 'react';
import { Button, Modal } from 'antd';

interface CancelCheckoutButtonProps {
  onCancel: () => void;
  isCanceling?: boolean;
}

/**
 * Cancel button for the steps before anything is registered. Cancelling
 * empties the cart, so ask first.
 */
const CancelCheckoutButton: FC<CancelCheckoutButtonProps> = ({
  onCancel,
  isCanceling,
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleConfirm = () => {
    setIsConfirmOpen(false);
    onCancel();
  };

  return (
    <>
      <Button
        type="default"
        size="large"
        onClick={() => setIsConfirmOpen(true)}
        loading={isCanceling}
        block
      >
        Cancel
      </Button>
      <Modal
        title="Cancel checkout?"
        open={isConfirmOpen}
        onOk={handleConfirm}
        onCancel={() => setIsConfirmOpen(false)}
        okText="Yes, empty my cart"
        cancelText="Keep my selections"
        okButtonProps={{ danger: true }}
      >
        <p>
          This removes all of the schedules in your cart. Nothing has been
          registered yet.
        </p>
      </Modal>
    </>
  );
};

export default CancelCheckoutButton;
